import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import pic11 from '../assets/images/pic11.jpg'
import esfera from '../assets/images/esferasaude.jpg'
import esferalogo from '../assets/images/esfera.png'
import favicon from '../assets/images/favicon.ico'

const Generic = (props) => (
    <div>
        <Helmet>
            <title>ESFERA SAÚDE</title>
            <link rel="shortcut icon" type="image/png" href={favicon} />
        </Helmet>
        <span className="image main"></span>
        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header>
                        <span className="image midlogo"><img src={esferalogo} alt=""/></span>
                    </header>
                    <span className="image main"><img src={esfera} alt="" /></span>
                    <p>Desde 2008 que a Esferasaúde faz tudo com o coração.
                        Após uma fase de expansão e de forte investimento, consolidamos a nossa aposta e mudamos hoje para uma estrutura mais simples. De clínicas especializadas na área dos Meios Complementares de Diagnóstico passamos a Unidades Médicas Especializadas de tratamento e diagnóstico.
                        Temos agora uma identidade diferente, mais madura e sólida mas queremos continuar a ser vitais para a vida dos nossos utentes e capazes de feitos extraordinariamente importantes.
                        Conte com uma equipa especializada. Conte com a Esferasaúde.
                    </p>

                    <p>Desenvolver, de forma sustentada, os melhores cuidados de saúde. Diferenciando-nos pelo rigor, ética e profissionalismo e por um ambiente humano e próximo, de absoluto respeito e empatia por todos quantos nos procuram. Trabalhamos com os melhores profissionais, promovendo o seu desenvolvimento contínuo, numa cultura de exigência e busca permanente da excelência.</p> 
                    <center><a href="http://www.esferasaude.pt/" className="button">Saber mais</a></center>
                </div>
            </section>
        </div>

    </div>
)

export default Generic


// WEBPACK FOOTER //
// ./src/pages/esfera.js